import axios from './financeiroApi';

const anexoApi = () => {
  return {
    downloadAnexo: async (url) => {
      return axios({
        url: `${url}`,
        method: 'GET',
        responseType: 'blob',
      });
    },
  };
};

export { anexoApi };
